import React, { useEffect, useState } from "react";
import { Box, Grid, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LoadingButton from "@mui/lab/LoadingButton";
import QTDetailsTextFieldWithLabelSection from "../../../../common/QTDetailsTextFieldWithLabelSection";

const AddAdminSendInviteModal = ({
  modalOpen,
  handleClose,
  handleSendInvite,
  loading,
  row,
}) => {
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    message: "",
  });

  useEffect(() => {
    if (row) {
      setUserData({
        name: row?.firstName + " " + row?.lastName || "",
        email: row?.email || row?.invitedUserEmail || "",
        message: "",
      });
    }
  }, []);
  return (
    <Modal open={modalOpen} onClose={handleClose}>
      <Box sx={audioModalStyles}>
        <Grid container direction={"column"}>
          <Grid container justifyContent={"flex-end"}>
            <CloseIcon
              onClick={handleClose}
              style={{ cursor: "pointer", marginTop: 10, marginBottom: 10 }}
            />
          </Grid>
          <Grid
            container
            direction={"column"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <span style={sendInviteTextStyles}>Send Invitation</span>
            {/*Name section*/}
            <QTDetailsTextFieldWithLabelSection
              label={"Name"}
              value={userData.name}
              onChange={(e) =>
                setUserData({
                  ...userData,
                  name: e.target.value,
                })
              }
            />
            {/*Email section*/}
            <QTDetailsTextFieldWithLabelSection
              label={"Email"}
              value={userData.email}
              onChange={(e) =>
                setUserData({
                  ...userData,
                  email: e.target.value,
                })
              }
            />
            {/*Message section*/}
            <QTDetailsTextFieldWithLabelSection
              label={"Message"}
              value={userData.message}
              multiline={true}
              rows={2}
              onChange={(e) =>
                setUserData({
                  ...userData,
                  message: e.target.value,
                })
              }
            />
            <LoadingButton
              variant="contained"
              loading={loading}
              disabled={loading}
              onClick={() => handleSendInvite(userData)}
              style={inviteButtonStyles}
            >
              Send Invitation
            </LoadingButton>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default AddAdminSendInviteModal;

const audioModalStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30% ",
  // height: "70%",
  bgcolor: "#fff",
  borderRadius: 2,
  p: 2,
};

const inviteButtonStyles = {
  color: "#fff",
  background: "#00A7CD",
  textTransform: "none",
  marginBottom: 20,
  fontFamily: "Avenir Book, sans-serif",
};

const sendInviteTextStyles = {
  color: "#020303",
  fontWeight: 600,
  fontSize: 24,
  marginBottom: 20,
  fontFamily: "Avenir Book, sans-serif",
};
